export default {
  title: "我的图片",
  countLabel: "{count} 张图片",
  uploadFloating: "上传照片",
  group: {
    referenceCount: "{count} 个风格",
  },
  referenceCreate: {
    ariaLabel: "使用其他参考图创建分析",
    loadingTitle: "正在准备图片",
    loadingMessage: "正在恢复原图，稍后将进入参考图选择。",
    failedTitle: "无法复用这张图片",
    failedMessage: "本地缓存图片不可用，请重新上传该图片。",
    networkError: "网络异常，无法获取原图，请稍后再试。",
  },
  dateFilter: {
    timeFilter: "按日期筛选",
    clearFilter: "清除日期筛选",
    allTime: "全部时间",
    last7Days: "最近7天",
    last30Days: "最近30天",
    noData: "暂无可筛选的日期数据",
  },
  empty: {
    title: "暂无图片",
    description: "开始上传后将在此查看图片",
    uploadAction: "开始上传",
    descriptionSuffix: "后将在此查看图片",
  },
  error: {
    title: "无法同步历史记录",
    description: "服务器暂不可达，未能刷新你的图片。",
    retry: "重试",
    uploadAction: "开始上传",
  },
  filteredEmpty: {
    title: "没有符合筛选条件的图片",
    description: "请尝试更换日期范围或清除筛选以查看全部图片。",
  },
  loading: "正在加载历史记录",
  loadingMore: "正在加载更多",
  syncWarning: "历史记录未能完全同步，当前展示本地缓存的图片。",
  deleteConfirm: {
    header: "确认删除",
    message: "您确定要删除该上传任务及其关联参考记录吗？此操作无法撤销。",
    accept: "删除",
    acceptPending: "正在删除…",
    reject: "取消",
    close: "关闭",
  },
  sheet: {
    title: "图片操作",
    openResult: "打开原图结果",
    referenceList: "风格",
    createReference: "用其他参考图创建",
    delete: "删除该记录",
    close: "关闭",
    count: "{count} 个风格",
  },
};
